import React from "react";
import styles from "./FirstSlider.module.scss";
import Slider from "../../../Slider/Slider";


import img1 from "./1.webp";
import img2 from "./2.jpg";
import img3 from "./3.jpg";
import img4 from "./4.webp";
const imagesArr = [
  { id: 1, imgUrls: [img1, img1, img1, img1] },
  { id: 2, imgUrls: [img2, img2, img2] },
  { id: 3, imgUrls: [img3, img3] },
  { id: 4, imgUrls: [img4] },
];

const FirstSlider: React.FC = () => {
  return (
    <section className={styles.mainSlider}>
      <div className={styles.container}>
        <Slider mode="mainSlider" images={imagesArr} />
      </div>
    </section>
  );
};

export default FirstSlider;
